export default __webpack_public_path__ + "static/media/Mongodb.2fa408d4.jpg";